import React, { createContext, useState, useContext } from 'react';

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const [pageTitle, setPageTitle] = useState('Dashboard'); // Default title

  return (
    <PageContext.Provider value={{ pageTitle, setPageTitle }}>
      {children}
    </PageContext.Provider>
  );
};

export const usePage = () => useContext(PageContext); 